import { render, staticRenderFns } from "./voteDetails.vue?vue&type=template&id=117e44d2"
import script from "./voteDetails.vue?vue&type=script&lang=js"
export * from "./voteDetails.vue?vue&type=script&lang=js"
import style0 from "./voteDetails.vue?vue&type=style&index=0&id=117e44d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports